import React from 'react';

const Modal = ({ isOpen, onClose, title, children }) => {
  if (!isOpen) return null;

  return (
    <div className="app-modal-overlay" onClick={onClose}>
      <div className="app-modal" onClick={(e) => e.stopPropagation()}>
        <div className="app-modal-header">
          <h2 className="app-modal-title">{title}</h2>
          <button
            onClick={onClose}
            className="app-modal-close"
            aria-label="Kapat"
          >
            &times;
          </button>
        </div>
        <div className="app-modal-body">{children}</div>
      </div>
    </div>
  );
};

export default Modal;
